import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { ReleaseGroupDetail } from '../../../../shared/releaseGroups';

/**
 * Prefix shared by the queries for a release group and its releases, so a single invalidation refreshes them.
 */
export const getReleaseGroupBaseQueryKey = (releaseGroupId: number): QueryKey => ['releaseGroups', String(releaseGroupId)];

//  Read by several components on the release group pages; saving the settings invalidates it.
const RELEASE_GROUP_STALE_TIME_MS = 60 * 1000;

export const getReleaseGroupQueryKey = (releaseGroupId: number): QueryKey =>
  [...getReleaseGroupBaseQueryKey(releaseGroupId), 'detail'];

function fetchReleaseGroup(releaseGroupId: number) {
  return get<ReleaseGroupDetail>(`/api/v2/release-groups/${releaseGroupId}`, true);
}

/**
 * Query for a single release group by its id. The response does not include the group's releases.
 */
export function useReleaseGroup(releaseGroupId: number, isEnabled = true) {
  return useQuery<ReleaseGroupDetail>({
    queryKey: getReleaseGroupQueryKey(releaseGroupId),
    queryFn: () => fetchReleaseGroup(releaseGroupId),
    enabled: isEnabled,
    staleTime: RELEASE_GROUP_STALE_TIME_MS,
  });
}
